import { ServicesURL, uploadFile } from "@utils/utilsApi";
import { MethodType } from "src/services/type";
import { CsvDiscardsFile } from "@components/CsvDiscardsModalCst";

export const uploadStaticGroupCsv = async (
  groupId: string | number,
  file: File,
): Promise<CsvDiscardsFile | null> => {
  const formData = new FormData();
  formData.append("file", file);
  const response: any = await uploadFile(
    `${ServicesURL.staticGroups}/static/${groupId}`,
    formData,
    MethodType.PUT,
  );
  const contentDisposition: string | undefined =
    response?.headers?.["content-disposition"];
  if (!contentDisposition || !contentDisposition.includes("filename")) {
    return null;
  }
  return {
    data: response.data,
    filename:
      contentDisposition.split("filename=")[1]?.replace(/["']/g, "").trim() ||
      "discards.csv",
    type: response?.headers?.["content-type"] || "text/csv",
  };
};
